import React, { useEffect } from "react";
import { useState } from "react";
import styled from "styled-components";
import camera from '../images/cameraWithBackground.svg';
import usePortalService from "../services/PortalService";
import { forwardRef, useImperativeHandle } from "react";

const Styles = styled.div `
    a {
        display: inline-block;
        position: relative;
    }
    a:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        opacity: 0;
        z-index: 1;
        transition: opacity 0.4s ease;
    }
    a:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: url(${camera});
        background-size: cover;
        opacity: 0;
        transition: opacity 0.4s linear;
        border-radius : 0.5em;
    }
    a:hover:before,
    a:hover:after {
        opacity: 0.5;
    }
`

type UploadableAvatarProps = {
    src: string
    style?: React.CSSProperties
}

const UploadableAvatar  = forwardRef(({src, style}: UploadableAvatarProps, ref) => {
    const {uploadAvatar} = usePortalService();

    const [file, setFile] = useState<File | null>(null);
    const [changed, setChanged] = useState(false);
    const [picture, setPicture] = useState(src);

    const inputRef = React.useRef<HTMLInputElement>(null);

    const reader  = new FileReader();
  
    reader.onloadend = () => {
      if (reader.result && typeof reader.result === 'string') {
        setPicture(reader.result);
      }
    }

    useEffect(() => {
        setPicture(src)
      }, [src])

    const handlerClick = () => {
      if (inputRef.current) {
        inputRef.current.click();
      }
    }

    const handleFile = (files: FileList | null) => {
      if (files && files.length > 0) {
        setFile(files[0]);
        setChanged(true)
        reader.readAsDataURL(files[0]);
      }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      e.preventDefault();
      if (e.target.files && e.target.files[0]) {
        handleFile(e.target.files);
      }
    };
  
    const uploadHandle = async () => {
      if (!changed) {
          return;
      }

      if (file) {
        const data = new FormData();
        data.append(`FileAvatar`, file, file.name);

        const result = await uploadAvatar(data);
        if (result.success && typeof reader.result === 'string') {
            localStorage.setItem('iconProfile', reader.result);
        }
      }
    };

    useImperativeHandle(ref, () => ({ save: uploadHandle }));

    return (
        <Styles>
            <input ref={inputRef} type="file" style={{display: 'none'}} onChange={handleChange} accept="image/png, image/jpeg"/>
            <a onClick={handlerClick} /* style={{backgroundImage: {camera}}} */>
                <img src={picture} style={style} onClick={handlerClick} /* preview={false} *//>
            </a>
        </Styles>
    )

})

UploadableAvatar.displayName = 'UploadableAvatar';
export default UploadableAvatar;